/**
 * One customer-facing plan name: "Solo Agent" or "2-Agent Team".
 * Older consent rows and Stripe metadata still say Solo, Team, or Solo Plan.
 * Reading those names treats them as the same plan. Rows already stored are
 * left as they are.
 */

function seatCountFromLabel(value) {
  const text = String(value || '');
  const agentTeam = /(\d+)\s*-\s*agent\s+team/i.exec(text);
  if (agentTeam) return Number(agentTeam[1]);
  const paren = /\((\d+)\s+agents?\)/i.exec(text);
  if (paren) return Number(paren[1]);
  const leading = /^(\d+)\s+agents?\b/i.exec(text.trim());
  if (leading) return Number(leading[1]);
  return null;
}

function isSoloPlanName(value) {
  const key = String(value || '').trim().toLowerCase();
  return key === 'solo' || key === 'solo plan' || key === 'solo agent';
}

function isTeamPlanName(value) {
  const key = String(value || '').trim().toLowerCase();
  if (!key || isSoloPlanName(key)) return false;
  if (key === 'team' || key === 'team plan' || key === 'teams') return true;
  if (key.startsWith('team plan') || key.startsWith('team -') || key.startsWith('team ')) return true;
  return /^\d+\s*-?\s*agent team$/.test(key);
}

function checkoutPlanLabel(planName, agents) {
  const raw = String(planName || '').trim();
  if (isTeamPlanName(raw)) {
    const count = Math.floor(Number(agents) || seatCountFromLabel(raw) || 0);
    if (count >= 2) return `${count}-Agent Team`;
    return 'Team';
  }
  if (!raw || isSoloPlanName(raw)) return 'Solo Agent';
  return raw;
}

function readConsentPlan(stored, agents) {
  return checkoutPlanLabel(stored, agents);
}

function consentPlansMatch(stored, current) {
  const left = String(stored || '').trim();
  const right = String(current || '').trim();
  if (!left || !right) return false;
  if (left.toLowerCase() === right.toLowerCase()) return true;
  const leftSolo = isSoloPlanName(left);
  const rightSolo = isSoloPlanName(right);
  if (leftSolo || rightSolo) return leftSolo && rightSolo;
  const leftTeam = isTeamPlanName(left);
  const rightTeam = isTeamPlanName(right);
  if (leftTeam && rightTeam) {
    const leftSeats = seatCountFromLabel(left);
    const rightSeats = seatCountFromLabel(right);
    if (leftSeats && rightSeats) return leftSeats === rightSeats;
    return true;
  }
  return false;
}

module.exports = {
  seatCountFromLabel,
  isSoloPlanName,
  isTeamPlanName,
  checkoutPlanLabel,
  readConsentPlan,
  consentPlansMatch,
};
